export const setState = (key, value) => {
  try {
    const serializedState = JSON.stringify(value);
    localStorage.setItem(key, serializedState);
  } catch (err) {
    return undefined;
  }
};

export const getState = (key) => {
  try {
    const serializedState = localStorage.getItem(key);
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {}
};

export const STORAGE_KEYS = {
  HOT_SESSION_DATA: "hot_auth_session-data",
  // Legacy global default-KB key (untyped tenant). New writes should use
  // `getKbDefaultStorageKey(tenant)` so HIG and HOT defaults don't bleed
  // across tenant switches on the same browser. Reads still consult this
  // legacy key as a fallback for GMAIL so existing HIG users keep their
  // default after this upgrade.
  KB_DEFAULT_ID: "kb_default_id",
  KB_ACTIVE_TENANT: "kb_active_tenant",
  KB_SOURCE: "kb_source"
};

// Tenant-scoped storage key for the per-user default KB id. Composing the
// tenant name into the key keeps HIG and HOT defaults isolated, so logging
// out as one tenant and into another doesn't pick up the other's default.
export const getKbDefaultStorageKey = (tenant) =>
  tenant ? `${STORAGE_KEYS.KB_DEFAULT_ID}_${tenant}` : STORAGE_KEYS.KB_DEFAULT_ID;

const PRESERVED_STATIC_KEYS = [
  STORAGE_KEYS.HOT_SESSION_DATA,
  STORAGE_KEYS.KB_DEFAULT_ID,
  STORAGE_KEYS.KB_ACTIVE_TENANT,
  STORAGE_KEYS.KB_SOURCE
];

// Dynamic prefixes — any key starting with these is preserved across the
// "logout but keep HOT session" clear. Covers `kb_default_id_<tenant>`.
const PRESERVED_KEY_PREFIXES = [`${STORAGE_KEYS.KB_DEFAULT_ID}_`];

const isPreservedKey = (key) =>
  PRESERVED_STATIC_KEYS.includes(key) ||
  PRESERVED_KEY_PREFIXES.some((prefix) => key.startsWith(prefix));

export const clearLocalStoragePreservingHotSession = () => {
  const preserved = {};
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && isPreservedKey(key)) {
      preserved[key] = localStorage.getItem(key);
    }
  }
  localStorage.clear();
  Object.entries(preserved).forEach(([key, value]) => {
    localStorage.setItem(key, value);
  });
};

// export const setState = (key, value) => {
//   try {
//     if (value) {
//       const serializedState = CryptoJS.AES.encrypt(
//         JSON.stringify(value),
//         "my-secret-key@123"
//       ).toString();
//       localStorage.setItem(key, serializedState);
//     }
//   } catch (err) {
//     return undefined;
//   }
// };

// export const getState = (key) => {
//   try {
//     const serializedState = localStorage.getItem(key);
//     if (serializedState === null) {
//       return undefined;
//     }
//     const decryptData = CryptoJS.AES.decrypt(
//       serializedState,
//       "my-secret-key@123"
//     ).toString();
//     return JSON.parse(decryptData.toString(CryptoJS.enc.Utf8));
//   } catch (err) {
//     return undefined;
//   }
// };
